import React, { useState, useEffect, useRef } from "react";
import { IoIosPause } from "react-icons/io";
import warning from "../../../img/warning.png";
import { IoCaretForwardOutline } from "react-icons/io5";
import { LiaCircle } from "react-icons/lia";
import NavHear from "./NavHear";
import Footer from "./TestFooter/Footer";
import { Link } from "react-router-dom";
import BackImg from "../../../img/back.svg";
import Modal from "react-modal";
import "./heartest.css";
import { ImCross } from "react-icons/im";

import AudioPlayer from "react-h5-audio-player";
import { useDispatch } from "react-redux";
import { testQuestion } from "../../../Helper/Redux/API";
function VoiceTest500() {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  const [question_id, setQuestionId] = useState("");

  const [audio, setAudio] = useState("");
  const dispatch = useDispatch();
  const getQuestion = () => {
    const data = {
      page_number: 10,
    };
    try {
      dispatch(testQuestion(data)).then((res) => {
        if (res?.payload?.status === true) {
          setAudio(res?.payload?.audio?.audio_2);
          setQuestionId(res?.payload?.data[0]?.id);
        }
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getQuestion();
  }, []);

  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = "#f00";
  }

  function closeModal() {
    setIsOpen(false);
  }

  const handleRadioChange = (e) => {
    // setTimeout(() => {
    //   onNext();
    // }, 1000);
  };
  const audioRef = useRef(null);
  const [volume, setVolume] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  console.log(volume, "volume volume");

  // useEffect(() => {
  //   // Set initial volume on mount
  //   if (audioRef.current && audioRef.current.audioEl) {
  //     audioRef.current.audioEl.volume = volume;
  //   }
  // }, [volume]);

  const handleVolumeDecrease = (value) => {
    if (volume >= 0.1) {
      setVolume(volume - value);
    } else {
      setVolume(0);
    }
  };

  const handleVolumeIncrease = (value) => {
    if (volume < 0.9) {
      setVolume(volume + value);
    } else {
      setVolume(1);
    }
  };
  const [onplaymusic, setOnPlayMusic] = useState(false);

  // new code
  const audioElementRef = useRef(null);
  const balanceSliderRef = useRef(null);
  const volumeSliderRef = useRef(null);
  const startButtonRef = useRef(null);
  const stopButtonRef = useRef(null);

  const [audioContext, setAudioContext] = useState(null);
  const [stereoPanner, setStereoPanner] = useState(null);
  const [gainNode, setGainNode] = useState(null);

  useEffect(() => {
    const context = new (window.AudioContext || window.webkitAudioContext)();
    setAudioContext(context);
    setStereoPanner(context.createStereoPanner());
    setGainNode(context.createGain());

    return () => {
      if (context.state !== "closed") {
        context
          .close()
          .catch((error) =>
            console.error("Error closing AudioContext:", error)
          );
      }
    };
  }, []);

  useEffect(() => {
    const audioSourceNode = audioContext?.createMediaElementSource(
      audioElementRef.current
    );
    const connectAudioNodes = () => {
      if (audioSourceNode && stereoPanner && gainNode) {
        audioSourceNode.connect(stereoPanner);
        stereoPanner.connect(gainNode);
        gainNode.connect(audioContext.destination);
      }
    };

    if (audioSourceNode) {
      audioSourceNode.connect(stereoPanner);
      stereoPanner.connect(gainNode);
      gainNode.connect(audioContext.destination);
    }

    return () => {
      if (audioSourceNode) {
        audioSourceNode.disconnect();
      }
    };
  }, [audioContext, stereoPanner, gainNode]);

  const handleStartButtonClick = async () => {
    setOnPlayMusic(true);
    setIsButtonDisabled(true);
    if (audioContext.state === "suspended") {
      await audioContext.resume();
    }

    // Set the balance to the left (-1) for the left ear
    stereoPanner.pan.value = 1;

    // Set the default frequency to 6 kHz
    audioElementRef.current.currentTime = 0; // Set the audio to the beginning
    // audioElementRef.current.playbackRate = 2; // Set the playback rate to 2 kHz

    // Set initial volume
    gainNode.gain.value = volumeSliderRef.current.value;

    // Start playing the audio
    audioElementRef.current
      .play()
      .catch((error) => console.error("Error playing audio:", error));
  };

  const handleStopButtonClick = () => {
    setOnPlayMusic(false);
    setIsButtonDisabled(false);
    // Pause and reset the audio
    audioElementRef.current.pause();
    audioElementRef.current.currentTime = 0;
  };

  const handleBalanceChange = () => {
    // Adjust balance
    const balanceValue = parseFloat(balanceSliderRef.current.value);
    stereoPanner.pan.value = balanceValue;
  };

  const handleVolumeChange = () => {
    // Adjust volume
    const volumeValue = parseFloat(volumeSliderRef.current.value);
    gainNode.gain.value = volumeValue;
  };

  const getCurrentVolume = () => {
    // Check if volumeSliderRef.current is not null before accessing value
    if (volumeSliderRef.current) {
      return parseFloat(volumeSliderRef.current.value);
    } else {
      console.error("volumeSliderRef.current is null or undefined");
      return null; // or handle the error appropriately
    }
  };

  // Log the current volume level before increasing or decreasing
  const initialVolume = getCurrentVolume();
  let step10data = {
    question_id: question_id,
    answer_id: initialVolume,
  };
  localStorage.setItem("Rightear500Hz", JSON.stringify(step10data));

  const handleIncreaseVolume = () => {
    // Increase volume
    const currentVolume = parseFloat(volumeSliderRef.current.value);
    const newVolume = Math.min(currentVolume + 0.1, 1);

    // Log the updated volume level
    console.log("Increased volume level:", newVolume);
    step10data = {
      question_id: question_id,
      answer_id: newVolume,
    };

    localStorage.setItem("Rightear500Hz", JSON.stringify(step10data));
    if (newVolume > 0.8) {
      // Show a popup or take any other action for high volume
      openModal();
    }

    volumeSliderRef.current.value = newVolume;
    gainNode.gain.value = newVolume;
  };

  const handleDecreaseVolume = () => {
    // Decrease volume
    const currentVolume = parseFloat(volumeSliderRef.current.value);
    const newVolume = Math.max(currentVolume - 0.1, 0);

    // Log the updated volume level
    console.log("Decreased volume level:", newVolume);
    step10data = {
      question_id: question_id,
      answer_id: newVolume,
    };

    localStorage.setItem("Rightear500Hz", JSON.stringify(step10data));
    volumeSliderRef.current.value = newVolume;
    gainNode.gain.value = newVolume;
  };

  const setPlaybackSpeed = (speed) => {
    if (audioElementRef.current) {
      audioElementRef.current.playbackRate = speed;
    }
  };

  // Usage example: Set the playback speed to 1.5x
  setPlaybackSpeed(0.8);

  return (
    <>
      <div className="test-from">
        <NavHear />{" "}
        <section className="step_form">
          <div className="container">
            {/* container start */}
            <section className="step_1 step2  wow  fadeInUp animated voicepage">
              <div className="Back_div">
                <Link to="/hearingtest/setup-instructions">
                  <img src={BackImg} alt="back" className="img-fluid" />
                </Link>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="step1_img">
                    <div style={{ display: "none" }}>
                      <label htmlFor="balanceSlider">Balance:</label>
                      <input
                        type="range"
                        id="balanceSlider"
                        max="1"
                        step="0.01"
                        value="0.01"
                        ref={balanceSliderRef}
                        onChange={handleBalanceChange}
                      />
                    </div>

                    <label htmlFor="volumeSlider" style={{ opacity: "0" }}>
                      Volume:
                    </label>
                    <input
                      type="range"
                      id="volumeSlider"
                      max="1"
                      step="0.01"
                      value="0.01"
                      style={{ opacity: "0" }}
                      ref={volumeSliderRef}
                      onChange={handleVolumeChange}
                    />
                    <div className="quiet_place">
                      <h2 className="text-light">Right ear</h2>
                      <h4 className="text-light mt-1 fw-light">500 Hz</h4>
                      <div className="khZ_voicetestmusic_cont">
                        <div>
                          {onplaymusic && (
                            <button
                              onClick={handleIncreaseVolume}
                              className="volume_controller_btn"
                            >
                              +
                            </button>
                          )}
                        </div>

                        {onplaymusic ? (
                          <button
                            id="stopButton"
                            onClick={handleStopButtonClick}
                            ref={stopButtonRef}
                          >
                            <IoIosPause className="music_off_icon" />
                          </button>
                        ) : (
                          <button
                            id="startButton"
                            onClick={handleStartButtonClick}
                            ref={startButtonRef}
                          >
                            <IoCaretForwardOutline className="music_on_icon" />
                          </button>
                        )}

                        <audio
                          id="audioPlayer"
                          // controls={false}
                          loop={true}
                          ref={audioElementRef}
                        >
                          <source src="/Right500hz.mp3" type="audio/mp3" />
                          <source src={audio} type="audio/mp3" />
                        </audio>

                        <div>
                          {onplaymusic && (
                            <button
                              className="volume_controller_btn"
                              onClick={handleDecreaseVolume}
                            >
                              -
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="voice_step_container">
                        <div>
                          <div className="active_circle"></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>

                      {isButtonDisabled ? (
                        <Link to="/hearingtest/measurement/right-1000">
                          <button className="btn next_measure">Next</button>
                        </Link>
                      ) : (
                        <button disabled className="btn next_measure">
                          Next
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="step1_text ">
                    <h1>Press the play button to start the tone</h1>
                    <p className="new_space">
                      Use the +/- buttons to adjust the loudness and find the
                      softest sound you can hear. Then press Next.
                    </p>
                    <div className="step2_seletct"></div>
                  </div>
                </div>
              </div>
            </section>
            {/* container end */}
          </div>
          {/* <Link to="/hearingtest/intro">
            {" "}
            <button className="btn">Let’s Start!</button>
          </Link> */}

          <Modal
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
            shouldCloseOnOverlayClick={false}
            id="warning"
          >
            <button onClick={closeModal} className="cross_btn_warning">
              <ImCross />
            </button>
            <div className="body">
              <img src={warning} alt="warning" className="img-fluid" />
              <h5>You have reached the maximum volume </h5>
              <Link to="/hearingtest/measurement/right-1000">
                <button className="btn"> I didn't hear anything </button>
              </Link>
              <br />
              <Link onClick={closeModal}> I'd like to try again </Link>
            </div>
          </Modal>
        </section>
        <Footer />
      </div>
    </>
  );
}

export default VoiceTest500;
